<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <div class="content_container" fxLayout="row">
    <div class="list_container mat-elevation-z5" fxLayout="column">
      <div class="new_header_container" fxLayout="row" fxLayoutAlign="start center">
        <span class="subtitle" i18n="employee label@@employee" style="text-transform: uppercase"
          >Employee</span
        >
        <div class="expand"></div>
        <button
          id="add_new_employee"
          type="button"
          mat-icon-button
          aria-label="new employee"
          *epgIfPermitted="[OneAppPermission.EMPLOYEE_WRITE]"
          (click)="onNewEmployeeClick()"
          class="add-button"
          color="secondary"
        >
          <fa-icon class="icon" [icon]="faPlus" aria-label="user settings button"></fa-icon>
        </button>
      </div>

      <mat-form-field class="search_field" appearance="outline">
        <mat-label i18n="@@searchTitle">Search</mat-label>
        <fa-icon
          matSuffix
          class="icon"
          [icon]="faSearch"
          aria-label="user settings button"
          style="padding-right: 10px"
        ></fa-icon>
        <input type="text" matInput [(ngModel)]="searchText" />
      </mat-form-field>
      <div class="list-count">
        @if (employees.length > 0) {
        <span>
          @if (isAdmin()) {
          <ng-container>
            <span i18n="Showing Number of used Licenses @@showingNumberOfUsedLicenses"
              >{{ employees.length + 10 }} of {{ totalLicenses }}</span
            >&nbsp;<span i18n="@@licenses">Licenses</span>
          </ng-container>
          }
        </span>
        }
      </div>
      <div id="employee_item_container" class="list_item_container">
        <div
          class="list_item"
          *ngFor="let employee of employees | employeeSearch: searchText"
          [routerLink]="employee.employeeId"
          routerLinkActive="active_item"
        >
          <div>
            {{ employee?.userName }}
          </div>
        </div>
      </div>
    </div>

    <div class="detail">
      <router-outlet></router-outlet>
      <!-- *ngIf="!showNewCustomerButton" -->
      <!-- <div fxFill fxLayoutAlign="center center" *ngIf="showNewCustomerButton">
                <button type="button" mat-stroked-button color="primary" aria-label="new user"
                    (click)="onNewUserClick()">
                    Neuen Kunden hinzufügen
                </button>
            </div> -->
    </div>
  </div>
</div>
